import { type DocumentReference } from '@principle-theorem/shared';

export interface IRoutable {
  uid: string;
  ref?: DocumentReference;
}

export function isReferralPortalUrl(url: string): boolean {
  const validUrlPattern =
    /^https:\/\/referrals\.(?:\w+\.)?principle\.dental(?:\/.*)?$/;
  return validUrlPattern.test(url);
}
